import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import { HiOutlineMail } from 'react-icons/hi';
import { FaVolumeMute, FaVolumeUp } from 'react-icons/fa';

const API =  process.env.REACT_APP_API_URL;

const HERO_VIDEO = '/videos/wavvy-hero.mp4';
const HERO_POSTER = '/images/wavvy.jpeg'; // fallback frame while video loads

export default function Home() {
  const [showButton, setShowButton] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const [featured, setFeatured] = useState([]);
  const [newArrivals, setNewArrivals] = useState([]);
  const videoRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => setShowButton(true), 5000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    axios.get(`${API}/api/products?page=0&size=4`).then(res => setFeatured(res.data.slice(0, 4)));
    axios.get(`${API}/api/products?sort=createdAt,desc&size=4`).then(res => setNewArrivals(res.data.slice(0, 4)));
  }, []);

  const getProductImageUrl = (url) => {
    if (!url) return 'https://via.placeholder.com/300';
    if (url.startsWith('/uploads/')) {
      return `${API}/images/${url.replace('/uploads/', '')}`;
    }
    return url;
  };

  const toggleSound = () => {
    if (!videoRef.current) return;
    videoRef.current.muted = !videoRef.current.muted;
    setIsMuted(videoRef.current.muted);
  };

  return (
    <div>
      {/* ===== Hero Video ===== */}
      <div className="h-screen w-screen overflow-hidden bg-black relative">
        <video
          ref={videoRef}
          className="absolute inset-0 w-full h-full object-cover"
          src={HERO_VIDEO}
          poster={HERO_POSTER}
          autoPlay
          loop
          muted={isMuted}
          playsInline
        />

        <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent" />

        {/* Sound toggle */}
        <button
          onClick={toggleSound}
          className="absolute bottom-6 right-6 z-10 flex items-center justify-center w-10 h-10 rounded-full text-white border border-white/30 hover:border-white/60 backdrop-blur-sm transition-all duration-500"
        >
          {isMuted ? <FaVolumeMute size={14} /> : <FaVolumeUp size={14} />}
        </button>

        {showButton && (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
            className="absolute bottom-16 left-1/2 -translate-x-1/2 z-10"
          >
            <Link
              to="/products"
              className="group relative inline-flex items-center gap-4 px-10 py-4 text-sm font-light tracking-[0.3em] uppercase text-white border border-white/30 hover:border-white/60 backdrop-blur-sm transition-all duration-500"
            >
              <span>Shop</span>
              <svg
                className="w-4 h-4 group-hover:translate-x-2 transition-transform duration-500"
                fill="none" stroke="currentColor" viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Link>
          </motion.div>
        )}
      </div>
    </div>
  );
}